import { useEffect, useMemo, useRef } from "react"
import { useField } from "formik"
import {
    fetchBillReceiver,
    ReceiptConfirmOrderDialogQuery,
} from "../../../../dialogs/receiptConfirmOrderDialog/receiptConfirmOrderDialogApi"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { DynamicConfigKey } from "../../form/formTypes"

type BillReceiverGuardProps = Readonly<{
    userId: number
}>

export function BillReceiverGuard({ userId }: BillReceiverGuardProps) {
    const [{ value: buyerParties }, , buyerPartiesHelpers] = useField(DynamicConfigKey.BUYER_PARTIES)
    const billReceiverId: number | undefined = buyerParties?.id

    const frozenIdRef = useRef<number | null>(null)
    if (frozenIdRef.current === null && billReceiverId != null) {
        frozenIdRef.current = billReceiverId
    }
    const frozenId = frozenIdRef.current

    const startedRef = useRef(false)
    const fetchedOnceRef = useRef(false)

    const enabled = useMemo(() => frozenId !== null && !fetchedOnceRef.current && !startedRef.current, [frozenId])

    useEffect(() => {
        if (enabled) startedRef.current = true
    }, [enabled])

    const { data, isLoading, isError } = useApiQuery(fetchBillReceiver, {
        queryName: ReceiptConfirmOrderDialogQuery.BILL_RECEIVER,
        dependencies: {
            userId,
            receiverId: frozenId ?? 0,
        },
        enabled: enabled && !!userId,
    })

    useEffect(() => {
        if (!startedRef.current || isLoading) return
        if (fetchedOnceRef.current) return
        fetchedOnceRef.current = true

        const notFound = !isError && !data?.billReceiver
        if (isError || notFound) {
            buyerPartiesHelpers.setValue(null)
        }
    }, [isLoading, isError, data, buyerPartiesHelpers])

    return null
}
